export class ApiUrl {
  /**
   * ApiUrl() gives the endpoint for the web api
   */
  public static webapiurl() {
    switch (window.location.host) {
      case 'lora.wser.wur.nl':
        return 'https://lora.wser.wur.nl/WebApi'
      case 'acc.lora.wser.wur.nl':
        return 'https://acc.lora.wser.wur.nl/WebApi'
      case 'tst.lora.wser.wur.nl':
        return 'https://tst.lora.wser.wur.nl/WebApi'
      default:
        return 'https://localhost:44365'
    }
  }
}
